export const MAX_NUM_OF_ITEMS_IN_PREVIEW_CARD = 5;
export const MAX_DAYS_FROM_TODAY_TO_VIEW_STATS = 180;
